module.exports = __webpack_public_path__ + "img/it-hzhb.ae48abcb.jpg";